import { useEffect, useRef, useState } from 'react';

const testimonials = [
  {
    name: 'Selin Arslan',
    role: 'Kuaför & Güzellik Salonu Sahibi',
    location: 'İstanbul',
    avatar: 'https://readdy.ai/api/search-image?query=turkish%20professional%20woman%20beauty%20salon%20owner%20smiling%20portrait%20clean%20background&width=80&height=80&seq=101&orientation=squarish',
    rating: 5,
    text: 'Web sitemiz vardı ama 3 yıldır hiç müşteri gelmiyordu. Smart Hizmet platformunu kurduktan sonra ilk haftada 12 yeni randevu aldım. WhatsApp entegrasyonu hayat kurtardı!',
    highlight: 'ilk haftada 12 yeni randevu',
    package: 'Smart Satış Platformu',
  },
  {
    name: 'Dr. Murat Yıldız',
    role: 'Estetik Klinik Hekimi',
    location: 'Ankara',
    avatar: 'https://readdy.ai/api/search-image?query=turkish%20male%20doctor%20professional%20headshot%20clinic%20white%20coat%20portrait&width=80&height=80&seq=102&orientation=squarish',
    rating: 5,
    text: 'Reklam bütçemin büyük kısmı boşa gidiyordu. Funnel yapısı kurulduktan sonra aynı bütçeyle 4 kat daha fazla müşteri gelmeye başladı. Gerçekten dönüşüm odaklı çalışıyor.',
    highlight: '4 kat daha fazla müşteri',
    package: 'Smart Pro Platform',
  },
  {
    name: 'Fatma Demir',
    role: 'Pilates & Yoga Stüdyosu',
    location: 'İzmir',
    avatar: 'https://readdy.ai/api/search-image?query=turkish%20woman%20fitness%20studio%20owner%20smiling%20professional%20portrait%20neutral%20background&width=80&height=80&seq=103&orientation=squarish',
    rating: 5,
    text: 'Kurulum inanılmaz hızlıydı, bir günde yayına girdik. Mobil tasarımı çok başarılı, müşterilerim telefondan kolayca ulaşıyor. Aylık gelirim %60 arttı.',
    highlight: 'aylık gelir %60 arttı',
    package: 'Smart Vitrin',
  },
  {
    name: 'Kemal Öztürk',
    role: 'Dijital Pazarlama Ajansı',
    location: 'İstanbul',
    avatar: 'https://readdy.ai/api/search-image?query=turkish%20young%20professional%20man%20agency%20owner%20smiling%20portrait%20office%20background&width=80&height=80&seq=104&orientation=squarish',
    rating: 5,
    text: 'Müşterilerimiz için Smart Hizmet kullanıyoruz. Her sektörde işe yarıyor. Form ve WhatsApp entegrasyonu harika, lead başına maliyet ciddi düştü.',
    highlight: 'lead başına maliyet düştü',
    package: 'Smart Pro Platform',
  },
  {
    name: 'Ayşe Kaya',
    role: 'Diş Kliniği Koordinatörü',
    location: 'Bursa',
    avatar: 'https://readdy.ai/api/search-image?query=turkish%20professional%20woman%20dental%20clinic%20coordinator%20smiling%20portrait%20clean%20background&width=80&height=80&seq=105&orientation=squarish',
    rating: 5,
    text: 'Daha önce reklam versek de kimse arayıp sormuyordu. Şimdi günde 5–8 yeni hasta talebi geliyor. Sistem gerçekten çalışıyor, sonuçlar konuşuyor.',
    highlight: 'günde 5–8 yeni hasta talebi',
    package: 'Smart Satış Platformu',
  },
  {
    name: 'Hasan Çelik',
    role: 'Oto Servis İşletmecisi',
    location: 'Konya',
    avatar: 'https://readdy.ai/api/search-image?query=turkish%20middle%20aged%20man%20auto%20service%20business%20owner%20portrait%20neutral%20background&width=80&height=80&seq=106&orientation=squarish',
    rating: 5,
    text: 'Dijital konularda hiç bilgim yoktu, her şeyi onlar halletti. Artık müşteriler WhatsApp\'tan yazıyor, randevu alıyor. Teknik bilgi gerekmeden bu kadar verimli olmak süper.',
    highlight: 'teknik bilgi gerekmeden verimli',
    package: 'Smart Vitrin',
  },
];

export default function TestimonialsSection() {
  const ref = useRef<HTMLDivElement>(null);
  const [activeIdx, setActiveIdx] = useState(0);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.testi-card').forEach((el, i) => {
              setTimeout(() => {
                (el as HTMLElement).style.opacity = '1';
                (el as HTMLElement).style.transform = 'translateY(0)';
              }, i * 100);
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  // Auto-rotate featured testimonial
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIdx((prev) => (prev + 1) % testimonials.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const Stars = () => (
    <div className="flex gap-0.5">
      {[...Array(5)].map((_, i) => (
        <i key={i} className="ri-star-fill text-gold text-sm" />
      ))}
    </div>
  );

  return (
    <section
      className="py-24 md:py-32 relative overflow-hidden"
      style={{ background: '#0d0d15' }}
    >
      <div className="absolute top-0 left-0 right-0 section-divider" />
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{ backgroundImage: 'radial-gradient(ellipse at 30% 50%, #f0b429, transparent 55%)' }}
      />

      <div className="max-w-6xl mx-auto px-4 md:px-8" ref={ref}>
        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-gold/10 border border-gold/20 px-4 py-2 rounded-full mb-5">
            <i className="ri-double-quotes-l text-gold text-sm" />
            <span className="text-gold text-sm font-semibold">Müşteri Referansları</span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-white mb-4 tracking-tight">
            Gerçekten{' '}
            <span className="text-gold-gradient">İşe Yarıyor mu?</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-xl mx-auto">
            100+ işletme sahibi sonuçlarla konuşuyor. İşte onların deneyimi:
          </p>

          {/* Stats bar */}
          <div className="flex flex-wrap items-center justify-center gap-8 mt-8">
            {[
              { value: '100+', label: 'Mutlu İşletme' },
              { value: '4.9/5', label: 'Ortalama Puan' },
              { value: '%340', label: 'Ort. Dönüşüm Artışı' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl font-black text-gold">{stat.value}</div>
                <div className="text-gray-500 text-xs mt-0.5">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Featured testimonial (large) */}
        <div className="glass-gold rounded-3xl p-8 md:p-10 mb-8 relative overflow-hidden transition-all duration-500"
          style={{ boxShadow: '0 0 60px rgba(240,180,41,0.1)' }}
        >
          <div className="absolute top-6 right-8 text-gold/10 text-[120px] font-black leading-none select-none">"</div>
          <div className="relative z-10 flex flex-col md:flex-row items-start gap-6">
            <div className="flex-shrink-0">
              <img
                src={testimonials[activeIdx].avatar}
                alt={testimonials[activeIdx].name}
                className="w-16 h-16 md:w-20 md:h-20 rounded-2xl object-cover object-top"
              />
            </div>
            <div className="flex-1">
              <Stars />
              <p className="text-white text-lg md:text-xl leading-relaxed mt-3 mb-4 font-medium">
                "{testimonials[activeIdx].text}"
              </p>
              <div className="inline-flex items-center gap-2 bg-gold/15 border border-gold/30 px-3 py-1.5 rounded-full mb-4">
                <i className="ri-sparkling-line text-gold text-xs" />
                <span className="text-gold text-xs font-bold">{testimonials[activeIdx].highlight}</span>
              </div>
              <div className="flex items-center justify-between flex-wrap gap-3">
                <div>
                  <div className="font-extrabold text-white">{testimonials[activeIdx].name}</div>
                  <div className="text-gray-400 text-sm">{testimonials[activeIdx].role} · {testimonials[activeIdx].location}</div>
                </div>
                <span className="text-xs glass border border-white/10 px-3 py-1 rounded-full text-gray-400">
                  {testimonials[activeIdx].package}
                </span>
              </div>
            </div>
          </div>

          {/* Dots */}
          <div className="flex items-center justify-center gap-2 mt-6">
            {testimonials.map((_, i) => (
              <button
                key={i}
                onClick={() => setActiveIdx(i)}
                className={`rounded-full transition-all duration-300 cursor-pointer ${
                  i === activeIdx ? 'w-6 h-2 bg-gold' : 'w-2 h-2 bg-white/20 hover:bg-white/40'
                }`}
              />
            ))}
          </div>
        </div>

        {/* Grid — all cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.map((t, idx) => (
            <div
              key={t.name}
              className={`testi-card glass rounded-2xl p-6 border transition-all duration-300 cursor-pointer card-hover ${
                idx === activeIdx ? 'border-gold/30 bg-gold/5' : 'border-white/5 hover:border-white/10'
              }`}
              style={{ opacity: 0, transform: 'translateY(20px)', transition: 'all 0.4s ease' }}
              onClick={() => setActiveIdx(idx)}
            >
              <div className="flex items-start gap-3 mb-4">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-11 h-11 rounded-xl object-cover object-top flex-shrink-0"
                />
                <div className="min-w-0">
                  <div className="font-bold text-white text-sm truncate">{t.name}</div>
                  <div className="text-gray-500 text-xs truncate">{t.role}</div>
                </div>
              </div>
              <Stars />
              <p className="text-gray-300 text-sm leading-relaxed mt-3 line-clamp-3">"{t.text}"</p>
              <div className="mt-3 inline-flex items-center gap-1.5 bg-gold/10 px-2.5 py-1 rounded-full">
                <i className="ri-sparkling-line text-gold text-xs" />
                <span className="text-gold text-[11px] font-semibold">{t.highlight}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
